import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ActionList } from '../../ActionList';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
import MoreVertical from '@dtsl/icons/dist/icons/react/MoreVertical';
function ListMoreActions(props) {
  const {
    moreActionsMetaData
  } = props;
  const {
    isMobile
  } = useIsMobile(1024);
  const listMoreActionsClasses = classNames({
    [moduleStyles['sib-list__more-actions']]: true,
    [moduleStyles['sib-list__more-actions-xs']]: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listMoreActionsClasses
  }, /*#__PURE__*/React.createElement(ActionList, moreActionsMetaData));
}
ListMoreActions.defaultProps = {
  moreActionsMetaData: {
    options: [],
    triggerButtonMetaData: {
      iconAlone: true,
      variant: 'tertiary',
      icon: /*#__PURE__*/React.createElement(MoreVertical, null),
      ariaLabel: 'list-actions'
    }
  }
};
ListMoreActions.propTypes = {
  moreActionsMetaData: PropTypes.object
};
export default ListMoreActions;